import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import CardholderProfileForm from './CardholderProfileForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import WizardCard from 'react/signups/card/common/WizardCard';
import cardholderProfileShape from 'react/signups/card/shapes/CardholderProfile';

export default function CardholderProfile({
  cardholderProfileData,
  moduleComplete,
  onEarlyComplete,
  setCardholderProfileData,
}) {
  const validationSchema = Yup.object().shape({
    firstName: schema.firstName.required(),
    lastName: schema.lastName.required(),
    address: schema.address.required(),
    dateOfBirth: schema.dateOfBirth.required(),
    mobile: schema.mobile,
    countryOfCitizenship: schema.countryOfCitizenship.required(),
    nonResidentAlien: Yup.string().when(['countryOfCitizenship'], {
      is: (countryOfCitizenship) => countryOfCitizenship !== 'US',
      then: () => schema.nonResidentAlien.required(),
      otherwise: () => schema.nonResidentAlien.nullable(),
    }),
  });

  const handleContinue = (values) => {
    setCardholderProfileData({
      firstName: values.firstName,
      lastName: values.lastName,
      address: values.address,
      dateOfBirth: values.dateOfBirth,
      mobile: values.mobile,
      countryOfCitizenship: values.countryOfCitizenship || '',
      nonResidentAlien: values.nonResidentAlien || '',
    });
  };

  return (
    <WizardCard>
      <CardHeader>Let’s order your first card!</CardHeader>
      <Formik
        initialValues={cardholderProfileData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldTouched, setFieldValue, setValues, values }) => (
          <>
            <CardholderProfileForm
              onChange={handleChange}
              onSkip={onEarlyComplete}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              setValues={setValues}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

CardholderProfile.propTypes = {
  cardholderProfileData: cardholderProfileShape.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  onEarlyComplete: PropTypes.func.isRequired,
  setCardholderProfileData: PropTypes.func.isRequired,
};
